import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Warning } from "@phosphor-icons/react";

// Whether the GA4 tag is on the pages (Marketing Pixels), so visits are collected at all.
export function GaTagStatus({ tags }) {
  const on = (tags || []).filter((t) => t.enabled !== false);
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="ga-tag-status">
      {on.length ? <CheckCircle size={14} weight="bold" className="text-emerald-700" /> : <Warning size={14} weight="bold" className="text-amber-700" />}
      {on.length ? <span>GA4 tag on your pages: <b>{on.map((t) => `${t.pixel_id} (${t.where})`).join(", ")}</b></span>
        : <span>No GA4 tag on your pages yet. Add your G- measurement ID as a company pixel in <Link to="/admin/pixels" className="underline">Marketing Pixels</Link> (placement: All pages).</span>}
    </div>
  );
}

const STEPS = [
  "In Google Cloud Console, pick or create a project and turn on the \u201cGoogle Analytics Data API\u201d.",
  "Create a service account (IAM & Admin \u2192 Service accounts), then add a key: Keys \u2192 Add key \u2192 JSON. A key file downloads.",
  "In GA4, open Admin \u2192 Property access management, add the service account's email (it ends in .iam.gserviceaccount.com) and give it the Viewer role.",
  "In GA4, open Admin \u2192 Property details and copy the Property ID (a number, not the G- ID).",
  "Save the Property ID and the whole key file in the secure key form so the app can read your stats.",
];

export function GaSteps() {
  return (
    <ol className="list-decimal space-y-1.5 pl-5 text-sm" data-testid="ga-setup-steps">
      {STEPS.map((s) => <li key={s}>{s}</li>)}
    </ol>
  );
}

export function GaSetup({ data }) {
  return (
    <section className="brut-card space-y-3 p-5" data-testid="ga-setup">
      <div className="font-chivo text-lg font-black uppercase tracking-tight">Connect Google Analytics</div>
      <GaTagStatus tags={data.tags} />
      <p className="text-xs text-zinc-700">The tag collects visits. To show those numbers here, the app needs read-only access to your GA4 property:</p>
      <GaSteps />
      <p className="text-[11px] text-zinc-500" data-testid="ga-setup-missing">Still needed: {data.missing.join(", ")}</p>
    </section>
  );
}
